import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { catchError, map, Observable, of } from 'rxjs';
import { CommonService } from './common/common.service';
import { FirestoreDataService } from './firestore-data.service';

interface LogEntry {
  message: string;
  createdOn: number;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(
    private firestore: Firestore,
    private commonService: CommonService,
    private firestoreDataService: FirestoreDataService
  ) { }

  public logWarning(msg: string) {
    this.addLogEntry({ message: msg, createdOn: Date.now() });
  }

  public logError(msg: string, error?: Error) {
    this.addLogEntry({ message: msg, error: error?.message || null, createdOn: Date.now() });
  }

  private async addLogEntry(data: LogEntry) {
    const userID = this.getSafeUserID();
    if (userID) {
      try {
        const path_id = "Z5SiZxPpJgOVRXAuXzan";
        const doc_data = data;
        const method = "update";

        await this.firestoreDataService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          method,
        }).subscribe({
          error: (err) => {
            console.error("Error updating userErrorLogCollection document:", err);
            throw err;
          }
        });
      } catch (error) {
        console.error("Error adding log entry:", error); // Log the error for debugging
        throw error; // Propagate the error
      }
    }
  }

  private getSafeUserID(): Observable<string | null> {
    return this.commonService.getUid("getSafeUserID").pipe(
      map((uid) => uid ?? null),
      catchError((err) => {
        console.error("[getSafeUserID$] Error fetching UID:", err);
        return of(null);
      })
    );
  }


  public logInfo(msg: string) {
    this.addLogEntry({ message: msg, createdOn: Date.now() });
  }
}
